export default __webpack_public_path__ + "static/today_at_apple_1-4f7e32815b9d7206b03098b90411abce.jpg";